export default "__VITE_ASSET__878ede78__"